import { TablePagination } from "@mui/material";
import { countryTr } from "../../util/countryTr";
import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getHost, disableHost } from "../../store/host/host.action";
import { OPEN_HOST_DIALOG } from "../../store/host/host.type";
import male from "../../assets/img/female.png";

import TablePaginationActions from "../../util/Pagination";
import HostEdit from "../Dialog/HostEdit";
import BlockReason from "../Dialog/BlockReason";

const HostTable = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { host } = useSelector((state) => state.host);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState("all");
  const [blockRow, setBlockRow] = useState(null);

  useEffect(() => {
    dispatch(getHost());
  }, [dispatch]);

  // sekme + arama birlikte suzulur
  const data = useMemo(() => {
    let list = host || [];
    if (tab === "active") list = list.filter((h) => !h.isBlock);
    if (tab === "blocked") list = list.filter((h) => h.isBlock);
    const v = search.trim().toUpperCase();
    if (!v) return list;
    return list.filter(
      (d) =>
        d?.name?.toUpperCase()?.indexOf(v) > -1 ||
        d?.email?.toUpperCase()?.indexOf(v) > -1 ||
        d?.bio?.toUpperCase()?.indexOf(v) > -1 ||
        d?.uniqueID?.toString()?.indexOf(v) > -1 ||
        d?.coin?.toString()?.indexOf(v) > -1 ||
        d?.country?.toUpperCase()?.indexOf(v) > -1 ||
        d?.age?.toString()?.indexOf(v) > -1
    );
  }, [host, tab, search]);

  useEffect(() => {
    setPage(0);
  }, [tab, search]);

  const counts = useMemo(
    () => ({
      all: (host || []).length,
      active: (host || []).filter((h) => !h.isBlock).length,
      blocked: (host || []).filter((h) => h.isBlock).length,
    }),
    [host]
  );

  const handleEdit = (row) => {
    sessionStorage.setItem("hostId", row?._id);
    dispatch({ type: OPEN_HOST_DIALOG, payload: row });
  };

  const handleInfo = (hostId) => history.push({ pathname: "/admin/host/hostProfile", state: { hostId } });

  const handleHistory = (id) => {
    sessionStorage.setItem("hostId", id);
    history.push({ pathname: "/admin/host/history", state: { hostId: id } });
  };

  const fallback = (e) => {
    e.target.onerror = null;
    e.target.src = male;
  };

  const coinText = (n) => (Number(n) || 0).toLocaleString("tr-TR");

  const S = styles;

  return (
    <>
      <div className="row py-2">
        <div className="col-6">
          <h4 className="hostTitle">Yayıncılar</h4>
        </div>
        <div className="col-6">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-home"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                  </svg>
                </Link>
              </li>
              <li className="active">
                <a href={() => false}> Yayıncılar </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row layout-top-spacing">
        <div className="col-lg-12 col-12 layout-spacing">
          <div className="statbox widget">
            <div className="widget-content widget-content-area" style={S.area}>
              <div style={S.toolbar}>
                <div style={S.tabs}>
                  {[
                    ["all", "Tümü", counts.all],
                    ["active", "Aktif", counts.active],
                    ["blocked", "Engelli", counts.blocked],
                  ].map(([key, label, n]) => (
                    <button
                      key={key}
                      type="button"
                      style={{ ...S.tab, ...(tab === key ? S.tabOn : {}) }}
                      onClick={() => setTab(key)}
                    >
                      {label} <span style={S.count}>{n}</span>
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  style={S.search}
                  placeholder="İsim, e-posta, ülke, ID ara…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              {data.length > 0 ? (
                (rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).map(
                  (row) => (
                    <div key={row._id} style={S.card}>
                      <img
                        src={row?.image}
                        onError={fallback}
                        alt=""
                        style={S.avatar}
                        draggable="false"
                        onClick={() => handleInfo(row?._id)}
                      />

                      <div style={S.info}>
                        <div style={S.nameRow}>
                          <span style={S.name}>{row?.name}</span>
                          {row?.uniqueID && <span style={S.id}>#{row.uniqueID}</span>}
                          {row?.isBlock ? (
                            <span style={{ ...S.badge, ...S.badgeRed }}>Engelli</span>
                          ) : (
                            <span style={{ ...S.badge, ...S.badgeGreen }}>Aktif</span>
                          )}
                        </div>

                        <div style={S.meta}>
                          <span style={S.lower}>{row?.email}</span>
                          <span style={S.dot}>•</span>
                          <span>{countryTr(row?.country) || "—"}</span>
                          <span style={S.dot}>•</span>
                          <span>{row?.age} yaş</span>
                          <span style={S.dot}>•</span>
                          <span style={S.coin}>{coinText(row?.coin)} coin</span>
                        </div>
                      </div>

                      <div style={S.actions}>
                        <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={() => handleInfo(row?._id)}>
                          Profil
                        </button>
                        <button
                          type="button"
                          style={{ ...S.btn, ...S.btnGhost }}
                          onClick={() => handleHistory(row?._id)}
                        >
                          Geçmiş
                        </button>
                        <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={() => handleEdit(row)}>
                          Düzenle
                        </button>
                        <button
                          type="button"
                          style={{ ...S.btn, ...(row?.isBlock ? S.btnGreen : S.btnRed) }}
                          onClick={() => setBlockRow(row)}
                        >
                          {row?.isBlock ? "Engeli kaldır" : "Engelle"}
                        </button>
                      </div>
                    </div>
                  )
                )
              ) : (
                <div style={S.empty}>{tab === "blocked" ? "Engelli yayıncı yok." : "Kayıt bulunamadı."}</div>
              )}

              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100, { label: "Tümü", value: data?.length || 1 }]}
                component="div"
                count={data?.length || 0}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                ActionsComponent={TablePaginationActions}
                labelRowsPerPage="Sayfa başına"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
              />
            </div>
          </div>
        </div>

        <HostEdit />
        <BlockReason
          row={blockRow}
          onClose={() => setBlockRow(null)}
          onConfirm={(reason) => {
            props.disableHost(blockRow, reason);
            setBlockRow(null);
          }}
        />
      </div>
    </>
  );
};

const styles = {
  area: { padding: 18 },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  tabs: { display: "flex", gap: 8 },
  tab: {
    border: "1px solid #e3e7ef",
    background: "#fff",
    color: "#5b6478",
    borderRadius: 10,
    padding: "8px 16px",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
  },
  tabOn: { background: "#4361ee", borderColor: "#4361ee", color: "#fff" },
  count: {
    display: "inline-block",
    marginLeft: 7,
    background: "rgba(0,0,0,.12)",
    borderRadius: 20,
    padding: "1px 8px",
    fontSize: 12,
  },
  search: {
    flex: "1 1 260px",
    maxWidth: 360,
    border: "1px solid #e3e7ef",
    borderRadius: 10,
    padding: "9px 14px",
    fontSize: 14,
    outline: "none",
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
    border: "1px solid #eceff5",
    borderRadius: 14,
    padding: 14,
    marginBottom: 12,
    background: "#fff",
    boxShadow: "0 1px 3px rgba(20,30,60,.05)",
  },
  avatar: {
    width: 62,
    height: 62,
    borderRadius: 12,
    objectFit: "cover",
    flexShrink: 0,
    background: "#f2f4f8",
    cursor: "pointer",
  },
  info: { flex: "1 1 320px", minWidth: 0 },
  nameRow: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  name: { fontWeight: 700, fontSize: 16, color: "#1b2334" },
  id: { color: "#8b93a7", fontSize: 13 },
  badge: { fontSize: 11, fontWeight: 700, borderRadius: 20, padding: "2px 10px" },
  badgeGreen: { background: "#e3f9ec", color: "#067647" },
  badgeRed: { background: "#ffe3e3", color: "#b42318" },
  meta: {
    marginTop: 4,
    fontSize: 13,
    color: "#6b7280",
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    alignItems: "center",
  },
  lower: { textTransform: "lowercase" },
  coin: { fontWeight: 600, color: "#b45309" },
  dot: { color: "#c8cddb" },
  actions: { display: "flex", gap: 8, flexWrap: "wrap", marginLeft: "auto" },
  btn: {
    border: "1px solid transparent",
    borderRadius: 10,
    padding: "8px 16px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  btnGhost: { background: "#fff", borderColor: "#dde2ec", color: "#42506b" },
  btnGreen: { background: "#12b76a", color: "#fff" },
  btnRed: { background: "#f04438", color: "#fff" },
  empty: { textAlign: "center", color: "#8b93a7", padding: "48px 0", fontSize: 15 },
};

export default connect(null, { getHost, disableHost })(HostTable);
